/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Strips the `freshInstall` query parameter from the URL bar so an
 * accidental iframe reload does not trigger a second storage wipe.
 *
 * The current `history.state` is carried over rather than cleared: the router
 * is created before this runs and has already stamped its entry index
 * (`idx`) and key there. Wiping it leaves the entry looking like one the
 * router never created, so a later browser Back onto it skips
 * `NavigationInterceptor` entirely and `canNavigateBackInHistory()` reports no
 * history at all.
 */
export function removeFreshInstallFromUrl(): void {
  const url: URL = new URL(window.location.href);
  url.searchParams.delete("freshInstall");
  window.history.replaceState(
    window.history.state,
    document.title,
    url.toString()
  );
}
